import { MAX_NUMBER_OF_CONVERSION_INPUTS } from "@/constants/constants";
import { getConversionInputNamespace } from "@/constants/namespaces";
import { useAudioInput } from "@/lib/zustand/useAudioInput";

export const getConversionInputStores = () =>
  Array.from({ length: MAX_NUMBER_OF_CONVERSION_INPUTS }, (_, index) =>
    useAudioInput.getState().getNamedStore(getConversionInputNamespace(index))
  );
